import React from 'react';
import { testimonialImages } from '../data/content';
export function Testimonials() {
  return <section className="bg-night-panel" data-id="element-229" data-mp="3kpuirmacsxk5">
      <div className="mx-auto max-w-content px-3 py-14 sm:px-6 lg:py-24" data-id="element-230" data-mp="3kr5vwcpovhnx">
        <div className="mx-auto max-w-2xl px-2 text-center" data-id="element-231" data-mp="3fym8ko17985x">
          <h2 className="font-display text-[1.75rem] font-semibold leading-tight tracking-tight text-parchment sm:text-4xl" data-id="element-232" data-mp="3b0krg8nc3ix3">
            Quienes ya recibieron nuestros materiales, nos recomiendan
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-parchment/70 sm:text-lg" data-id="element-233" data-mp="31zd2wiamdwg7">
            Experiencias reales de personas que ya compraron en Tu Conexión Educativa.
          </p>
        </div>

        <div className="mx-auto mt-10 flex max-w-3xl flex-col gap-8 sm:mt-12 sm:gap-10" data-id="element-234" data-mp="2s2i5k2q3223i">
          {testimonialImages.map(image => <img key={image.src} src={image.src} alt={image.alt} loading="lazy" className="block h-auto w-full object-contain" data-id="element-235" data-mp="v8ncpcxfipjo" />)}
        </div>
      </div>
    </section>;
}